import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { StoreProvider } from "@/context/StoreContext";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Collections from "@/pages/Collections";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentReturn";
import About from "@/pages/About";
import ImportExport from "@/pages/ImportExport";
import Contact from "@/pages/Contact";
import Cgv from "@/pages/Cgv";
import Credits from "@/pages/Credits";
import SignIn from "@/pages/account/SignIn";
import SignUp from "@/pages/account/SignUp";
import Account from "@/pages/account/Account";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const Shell = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <div className="App">
      <StoreProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Shell><Home /></Shell>} />
            <Route path="/collections" element={<Shell><Collections /></Shell>} />
            {/* /product/:id accepts a human-readable slug, a UUID or a reference id */}
            <Route path="/product/:id" element={<Shell><ProductDetail /></Shell>} />
            <Route path="/products/:id" element={<Shell><ProductDetail /></Shell>} />
            <Route path="/cart" element={<Shell><Cart /></Shell>} />
            <Route path="/checkout" element={<Shell><Checkout /></Shell>} />
            <Route path="/payment/success" element={<Shell><PaymentSuccess /></Shell>} />
            <Route path="/payment/cancel" element={<Shell><PaymentCancel /></Shell>} />
            <Route path="/about" element={<Shell><About /></Shell>} />
            <Route path="/import-export" element={<Shell><ImportExport /></Shell>} />
            <Route path="/contact" element={<Shell><Contact /></Shell>} />
            <Route path="/cgv" element={<Shell><Cgv /></Shell>} />
            <Route path="/terms" element={<Navigate to="/cgv" replace />} />
            <Route path="/credits" element={<Shell><Credits /></Shell>} />
            <Route path="/account" element={<Shell><Account /></Shell>} />
            <Route path="/account/login" element={<Shell><SignIn /></Shell>} />
            <Route path="/account/register" element={<Shell><SignUp /></Shell>} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" theme="dark" toastOptions={{ classNames: { toast: 'bg-nw-espresso border-nw-gold/30 text-nw-ivory', actionButton: 'bg-nw-gold text-nw-black' } }} />
        </BrowserRouter>
      </StoreProvider>
    </div>
  );
}

export default App;
